export default "__VITE_ASSET__BfbiHnQc__"